'use client';

import { fillItems } from '$/(application)/apply/[productId]/lib/tracking/shared/fillItems';
import { fillVerticalCode } from '$/(application)/apply/[productId]/lib/tracking/shared/fillVerticalCode';
import { CmsApplyRewardProduct } from '$/(cms)/_modules/cmsService/types/applyRewardProduct';

export type TrackProduct = Pick<
  CmsApplyRewardProduct,
  | 'productDisplayName'
  | 'productId'
  | 'productName'
  | 'productUid'
  | 'catalogueProduct'
>;

export function createTrackingParameters(product: TrackProduct) {
  const catalogueProduct = product.catalogueProduct;

  return {
    itemId: catalogueProduct?.uid ?? product.productUid ?? '',
    itemName:
      catalogueProduct?.product_name ?? product.productDisplayName ?? '',
    itemBrand: catalogueProduct?.provider?.provider_name ?? '',
    rewardCampaignName:
      product.productName ??
      product.productDisplayName ??
      catalogueProduct?.product_name ??
      '',
    rewardCampaignId: product.productId,
  };
}

export function createItemTracking(product: TrackProduct, index?: number) {
  const trackingParameters = createTrackingParameters(product);
  const { items } = fillItems({
    productUid: trackingParameters.itemId,
    productName: trackingParameters.itemName,
    productProviderName: trackingParameters.itemBrand,
  });

  if (typeof index === 'undefined') {
    return { items };
  }

  return {
    items: items.map((item) => ({
      ...item,
      index: String(index),
    })),
  };
}

export function createBaseTracking(
  product: TrackProduct,
  stepNumber: string,
  stepName: string,
) {
  const trackingParameters = createTrackingParameters(product);

  return {
    lead_id: '',
    reward_campaign_name: trackingParameters.rewardCampaignName,
    reward_campaign_id: trackingParameters.rewardCampaignId,
    step_number: stepNumber,
    step_name: stepName,
    ...fillVerticalCode({
      productUid: trackingParameters.itemId,
    }),
  };
}
